'use strict';

angular.module('study.import', [
    'route',
    'study.i18n',
]);
